module.exports = __webpack_public_path__ + "img/support.86b24f7c.svg";